import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import BottomTray from '../BottomTray/BottomTray';
import styles from './GiftTray.module.scss';

type Props = {
  closeTray: () => void;
};

const GiftTray = ({ closeTray }: Props) => {
  return (
    <BottomTray closeTray={closeTray}>
      <div className={styles.container}>
        <div className={styles.trayContent}>
          <div className={styles.spacer} />
          <div className={styles.buttonContainer}>
            <div className={styles.headline}>
              <FormattedMessage defaultMessage="Choose a checkout method" />
            </div>
            <div className={styles.loginButton}>
              <Button linkInfo={{ href: '/login' }} text={<FormattedMessage defaultMessage="Log in" />} variant="primary" width="full" />
            </div>
            <Button
              allowWrap
              linkInfo={{ href: '/gift/payment', prefetch: true }}
              text={<FormattedMessage defaultMessage="Checkout as guest" />}
              variant="secondary"
              width="full"
            />
          </div>
        </div>
      </div>
    </BottomTray>
  );
};

export default GiftTray;
